const BaseModule = require('../../../90_utils/base/BaseModule');

class CEOHero extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$expandedInfo = this.$el.find('.expanded-info');
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
		this.$el.find('.goop-button').on('click', this._onClick.bind(this));
	}

	_removeListeners(){

	}

	//

	_onClick(e){
		this.toggle();
	}

	_onOut(e){
		if(!this.$expandedInfo[0].contains(e.target)){
			this.toggle(false);
		}
	}

	//

	toggle(value){

		if(value === true){
			this.$el.addClass('is-expanded');
		}
		else if(value === false){
			this.$el.removeClass('is-expanded');
		}
		else {
			this.$el.toggleClass('is-expanded');
		}

		$('#main').off('click', $.proxy(this._onOut, this));

		if(this.$el.hasClass('is-expanded')){
			window.requestAnimationFrame(() => {
				$('#main').on('click', $.proxy(this._onOut, this));
			});
		}
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }

	_resize(){

		let $textContent = this.$el.find('.text-content');
		let $contentWrapper = this.$el.find('.content-wrapper');
		let $expandedInfo = this.$el.find('.expanded-info');

		if(window.SETTINGS.breakpoint.minWidth('screen-small')){

			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});

			let textHeight = $textContent.outerHeight();
			let winHeight = window.SETTINGS.coords.winHeight;

			if(textHeight + 160 > winHeight){
				$contentWrapper.css('height', textHeight + 160);
			}
			else {
				$contentWrapper.css('height', '');
			}
		}
		else if(window.SETTINGS.breakpoint.minWidth('screen-phablet') && window.SETTINGS.breakpoint.maxWidth('screen-small')){

			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});

			let textHeight = $textContent.outerHeight();

			$expandedInfo.css({
				top: `calc(50% - ${Math.round((textHeight + 160)/2)}px`,
				height: textHeight + 160
			});
		}
		else {
			TweenMax.set([$textContent, $contentWrapper, $expandedInfo], {clearProps: 'all'});
		}
	}
}

module.exports = CEOHero;
